var installedChunks = {"vendors-node_modules_apollo_client_node_modules_graphql-tag_lib_index_js-node_modules_formik_-9e033e": 0,};
var uniqueName = "smartfdi-bo";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadCssChunkData = (target, chunkId) => {

installedChunks[chunkId] = 0;

} 
var loadingAttribute = "data-rspack-loading";
var loadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == uniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");

if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", uniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load") link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
loadCssChunkData(__webpack_require__.m, 0, "vendors-node_modules_apollo_client_node_modules_graphql-tag_lib_index_js-node_modules_formik_-9e033e");
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(installedChunks, chunkId)
		? installedChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(src_app_(models_back\-office\-pages_duns_ts\-src_app_pages_back\-office\-pages_investment_(invest(men\-34a0ba|or\-\-cc3a72)|offers\-li\-d710f4|reinvestm\-dbc26a)|helpers_(formatter_tsx\-src_app_pages_client\-pages_client\-contract\-details_index_ts\-nod\-78b7ac|permissions_ts\-src_app_hooks_back\-office\-pages_use\-user\-can\-edit_ts\-src_app_p\-4fd410)|pages_(back\-office\-pages_(payments_(invest(igation\-details_index_ts\-node_modules_rc\-tabs_\-601726|ments\-payout\-details_index_ts\-node_modules_rc\-\-bbc198)|general\-ledger(\-reconciliations_index_ts\-node_modules\-6e812b|s_index_ts\-node_modules_rc\-tabs_assets\-eb3cda)|bank\-(statement(\-details_index_ts\-node_modules_rc\-tabs\-b8c0d6|s\-list_index_ts\-node_modules_rc\-tabs_a\-602238)|transaction\-details_index_ts\-node_modules_rc\-ta\-1f41f1)|factoring\-payout\-details_index_ts\-node_modules_rc\-ta\-ba7407|payouts\-list_index_ts\-node_modules_rc\-tabs_assets_in\-52772f)|loan\-book_(loan(\-details_index_ts\-node_modules_rc\-tabs_assets_i\-d6f42f|s\-list_index_ts\-node_modules_rc\-tabs_assets_index_css)|debt\-collection\-(details_index_ts\-node_modules_rc\-ta\-626bc7|list_index_ts\-node_modules_rc\-tabs_\-acf124)|credit\-line\-(details_index_ts\-node_modules_rc\-tabs_a\-48b856|list_index_ts\-node_modules_rc\-tabs_asse\-467847)|reverse\-factoring\-(details_index_ts\-node_modules_rc\-\-dda400|list_index_ts\-node_modules_rc\-tab\-9a5a64)|notes\-list_index_ts\-node_modules_rc\-tabs_assets_ind\-b556a7|payout\-details_index_ts\-node_modules_rc\-tabs_assets\-a70b12)|investment_(task\-(details_index_ts\-node_modules_rc\-tabs_assets_\-eca458|manager_index_ts\-node_modules_rc\-tabs_assets_\-810e83)|investor(\-details_index_ts\-node_modules_rc\-tabs_ass\-f26965|s\-list_index_ts\-node_modules_rc\-tabs_asset\-217b9f)|notes\-list_index_ts\-node_modules_rc\-tabs_assets_in\-8e1f20|offer\-details_index_ts\-node_modules_rc\-tabs_assets\-bc2dd0)|system\-preferences_(broker\-details_index_ts\-node_modules_rc\-ta\-ae2b7b|debtor\-group\-details_index_ts\-node_modules\-708028|reporting_index_ts\-node_modules_rc\-tabs_as\-e3989a|system_index_ts\-node_modules_rc\-tabs_asset\-b2f89b|user\-details_index_ts\-node_modules_rc\-tabs\-904c03)|factoring_(outstanding\-verification\-task(\-details_index_ts\-node\-b9f01e|s_index_ts\-node_module\-10c75b)|debt\-collection\-(details_index_ts\-node_modules_rc\-ta\-22d81e|list_index_ts\-node_modules_rc\-tabs_\-8e8225)|ai\-task(\-d(etails_index_ts\-node_modules_rc\-tabs_asset\-bbdd19|ocument\-details_index_ts\-node_modules_rc\-t\-f19056)|s_index_ts\-node_modules_rc\-tabs_assets_index_css)|bulk\-external\-verification\-task(\-details_index_ts\-no\-444e98|s_index_ts\-node_modu\-998f2b)|client\-requirements_index_ts\-node_modules_rc\-tabs_a\-650849|invoice\-details_index_ts\-node_modules_rc\-tabs_asset\-63d213|notes\-list_index_ts\-node_modules_rc\-tabs_assets_index_css)|clients_(debtor(\-details_index_ts\-node_modules_rc\-tabs_assets_i\-728b18|s\-list_index_ts\-node_modules_rc\-tabs_assets_index_css)|client(s\-(details_index_ts\-node_modules_rc\-tabs_assets_\-ab221d|list_index_ts\-node_modules_rc\-tabs_assets_index_css)|\-credit\-note\-details_index_ts\-node_modules_rc\-t\-7773f1|\-settlement\-details_index_ts\-node_modules_rc\-ta\-94fe0b)|factoring\-contract\-details_index_ts\-node_modules_rc\-t\-9b61a6|loan\-book\-contract\-details_index_ts\-node_modules_rc\-t\-16f38a)|risk\-management_(monitoring\-task(\-details_index_ts\-node_modules\-f42350|s_index_ts\-node_modules_rc\-tab\-d5b14f)|prospect(\-(de(btor\-details_index_ts\-node_modules\-33f5a6|tails_index_ts\-node_modules_rc\-tab\-a106b3)|kyc\-details_index_ts\-node_modules_rc\-590ec2)|s\-list_index_ts\-node_modules_rc\-tabs_\-6e3145)|limit\-increase(\-(de(btor\-(details_index_ts\-node_m\-51fe61|history\-details_index_t\-3dce93)|tails_index_ts\-node_modules_\-44f345)|history\-details_index_ts\-node_\-be8609)|_index_ts\-node_modules_rc\-tabs_\-6ecc9b)|stoplist(\-company\-details_index_ts\-node_module\-e54862|\-person\-details_index_ts\-node_modules\-7c677d|_index_ts\-node_modules_rc\-tabs_assets\-f46f05)|annual\-review(\-(de(btor\-details_index_ts\-node_mo\-d4fde7|tails_index_ts\-node_modules_r\-f3b3fd)|kyc\-details_index_ts\-node_modul\-6389d0)|_index_ts\-node_modules_rc\-tabs_a\-d9053e)|contract\-details_index_ts\-node_modules_rc\-tab\-acba55|reports_index_ts\-node_modules_rc\-tabs_assets_\-dafefa))|client\-pages_(loan\-book\-(payout(\-details_index_ts\-node_modules_rc\-tabs_assets_index_css|s\-list_index_ts\-node_modules_rc\-tabs_assets_index_\-4ec1aa)|contract\-details_index_ts\-node_modules_rc\-tabs_assets_in\-68825c)|settlement(\-details|s\-list)_index_ts\-node_modules_rc\-tabs_assets_index_css|(((debto|use)rs\-list|reports)_index_ts|notes\-list_notes\-list\-page_tsx)\-node_modules_rc\-tabs_assets_index_css|client\-credit\-note\-details_index_ts\-node_modules_rc\-tabs_assets_in\-6ab2e5))|graphql_(auth_queries_ts\-src_app_hooks_use\-logout_ts\-(src_app_pages_(client\-pages_(debtor\-777d82|invoic\-214c27)|back\-office\-pages_p\-4f615b)|node_modules_rc\-tabs_assets_index\-8908e7)|back\-office\-pages_clients_client\-debtor\-details_risk\-reports\-tab_queries_ts\-s\-90ad32)|components_(address_index_ts\-src_app_(pages_back\-office\-pages_(clients_client\-debtor\-det\-d17ff6|risk\-management_annual\-re\-45817d)|components_preview\-edit\-card_index_ts\-src_app_pag\-c1d33d)|preview\-edit\-card_index_ts\-src_app_pages_back\-office\-pages_investment_inve\-a70264)|atoms_redirect_index_ts\-src_app_graphql_auth_queries_ts\-src_app_hooks_use\-logout_ts\-s\-d72f03)|node_modules_react\-data\-grid_lib_styles_css|vendors\-node_modules_apollo_client_node_modules_graphql\-tag_lib_index_js\-node_modules_formik_\-9e033e)$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = installedChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(installedChunks, chunkId)) {
						installedChunkData = installedChunks[chunkId];
						if (installedChunkData !== 0) installedChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								loadCssChunkData(__webpack_require__.m, chunkId);
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					loadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else installedChunks[chunkId] = 0;
		}
	}
};
